import React from "react";
import { ButtonProps, IconButton } from "sprint-common-web";

type AddToMergeListButtonProps = Pick<ButtonProps, "disabled" | "onClick">;

export const AddToMergeListButton: React.FC<AddToMergeListButtonProps> = (props: AddToMergeListButtonProps) => (
    <IconButton
        tooltipContent="Add to merge list"
        iconProps={{ iconName: "Merge" }}
        disabled={props.disabled}
        onClick={props.onClick}
    />
);
